/**
 * Anonymous version of seedgreen API axios (for unauthenticated requests)
 */
import axios from "axios";

export const SEEDGREEN_BASE_URL =
	import.meta.env.NODE_ENV === "test"
		? "http://localhost"
		: import.meta.env.VITE_SEEDGREEN_API_BASE_URL || ""; // Absolute URL needed for MSW in tests. Use VITE_SEEDGREEN_API_BASE_URL for LAN testing, otherwise use relative paths in dev/prod - Vite proxy handles routing in dev, Vercel rewrites in prod

const seedgreenAPIAnonymous = axios.create({
	baseURL: SEEDGREEN_BASE_URL + "/API",
	withCredentials: true,
	headers: {
		"Content-Type": "application/json",
	},
});

export default seedgreenAPIAnonymous;
